'use strict';

export const isHttpStatusSuccessful = status => {
  return status >= 200 && status < 300;
};
